import { Button, Card } from '../../PrizeDraw/components/ui';
import {
  SKILL_TEST_ANSWER_DEADLINE_MINUTES,
  SKILL_TEST_MAX_ATTEMPTS,
} from '../skillTestUtils';

type RulesConfirmationProps = {
  onStart: () => void;
  isStarting: boolean;
};

export function RulesConfirmation({ onStart, isStarting }: RulesConfirmationProps) {
  return (
    <Card className='p-8 shadow-[0_10px_30px_rgba(0,0,0,0.08)]'>
      <div className='mb-2 inline-flex rounded-full bg-[#FFF8E6] px-3 py-1 text-[11px] font-semibold text-[#C9963F]'>
        Skill-testing question
      </div>
      <h1 className='mb-3 font-display text-[26px] font-semibold text-[#0A0B14]'>
        Ready to begin?
      </h1>
      <p className='mb-5 text-[15px] leading-6 text-[#5B6478]'>
        To claim your rent credit, you must correctly answer a skill-testing question, on your own.
        When you tap Start, a math question appears and a {SKILL_TEST_ANSWER_DEADLINE_MINUTES}
        -minute timer begins right away. You can&apos;t pause it.
      </p>

      <ul className='mb-6 space-y-3 text-left text-[14px] leading-6 text-[#374151]'>
        <li className='flex gap-2'>
          <span className='mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0055FF]' aria-hidden='true' />
          <span>
            A four-operation math question appears, and the {SKILL_TEST_ANSWER_DEADLINE_MINUTES}
            -minute timer starts the moment it does.
          </span>
        </li>
        <li className='flex gap-2'>
          <span className='mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0055FF]' aria-hidden='true' />
          <span>
            You must answer it yourself, no help from another person, and no calculator, app, or
            other aid.
          </span>
        </li>
        <li className='flex gap-2'>
          <span className='mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0055FF]' aria-hidden='true' />
          <span>
            You have up to {SKILL_TEST_MAX_ATTEMPTS} attempts. If an answer is wrong and you have
            attempts left, you can try again, but the timer keeps running.
          </span>
        </li>
        <li className='flex gap-2'>
          <span className='mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0055FF]' aria-hidden='true' />
          <span>
            If the timer runs out, or all attempts are used without a correct answer, you
            won&apos;t qualify to claim this rent credit.
          </span>
        </li>
        <li className='flex gap-2'>
          <span className='mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#0055FF]' aria-hidden='true' />
          <span>Answer correctly within the time and attempts, and you qualify.</span>
        </li>
      </ul>

      <Button
        variant='gold'
        className='w-full justify-center py-3 text-[15px] disabled:cursor-not-allowed disabled:opacity-60'
        onClick={onStart}
        disabled={isStarting}
      >
        {isStarting ? 'Starting…' : 'Start'}
      </Button>
    </Card>
  );
}
